import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toast } from "react-toastify";

/**
 * Warning shown when sign-in is attempted from an in-app browser (Instagram,
 * LinkedIn, etc.) where Google OAuth is unreliable. Guides the user to reopen
 * the link in a real browser, or copy it to paste elsewhere.
 */
export default function InAppBrowserDialog({ open, onClose }) {
  const handleCopyLink = () => {
    navigator.clipboard.writeText("https://curateapp.io");
    onClose();
    toast.success("Link copied to clipboard");
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="browser-warning-dialog">
      <DialogTitle id="browser-warning-dialog">
        ⚠️ Unsupported browser detected
      </DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          You're currently using an in-app browser (like Instagram or LinkedIn),
          which may not work properly.
        </Typography>
        <Typography gutterBottom>
          To continue, tap the three dots (⋮ or …) in the top corner and select
          "Open in external browser".
        </Typography>
        <Typography gutterBottom>
          Or, copy the link and paste it into your browser app (like Chrome or
          Safari).
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="outlined"
          startIcon={<ContentCopyIcon />}
          onClick={handleCopyLink}
        >
          Copy link
        </Button>
        <Button onClick={onClose} variant="contained">
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );
}
